// Shared Figma link check and guidance copy for every Aero Figma link input.
// Aero only. Figmafolio keeps its own checks in FolioForm / ViewportEditor.
import { isWrongUrlType } from './viewportUtils';

export const FIGMA_SHARE_HINT =
  "In Figma, set Share to 'Anyone with the link can view', then copy the prototype link (it has /proto/ in it).";
export const FIGMA_HELP_URL =
  'https://help.figma.com/hc/en-us/articles/360040531773-share-files-and-prototypes';
export const FIGMA_PASSWORD_HINT =
  'Want a gate in front of it? Password protection is in Settings, on Basic and up.';

// Returns { ok, message }. Empty is not ok but has no message (nothing to warn about yet).
export function checkFigmaLink(raw) {
  const url = (raw || '').trim();
  if (!url) return { ok: false, message: null };
  if (isWrongUrlType(url)) {
    return {
      ok: false,
      message:
        "That's a design link. In Figma, open the prototype with Present (the play button), then copy that link. It has /proto/ in it.",
    };
  }
  if (!url.includes('figma.com/proto') && !url.includes('figma.com/embed')) {
    return {
      ok: false,
      message: 'Paste a Figma prototype link (figma.com/proto/...).',
    };
  }
  return { ok: true, message: null };
}
